import React from 'react';
import { FunctionColor, Preset } from '@lux/text';
import { Translate } from '@pegasus/translation';
import { TextLink } from '@lux/text-link';
import * as S from './styles';
export var ErrorCard = function () {
    var handleRefreshPage = function () {
        window.location.reload();
    };
    return (React.createElement(S.ErrorCard, null,
        React.createElement(S.ErrorCardContent, null,
            React.createElement(S.ErrorHeadline, { preset: Preset.XXL, bold: true, color: FunctionColor.function100 },
                React.createElement(Translate, { message: "error.headline" })),
            React.createElement(S.ErrorCaption, { preset: Preset.M, color: FunctionColor.function100 },
                React.createElement(Translate, { message: "error.message" })),
            React.createElement(TextLink, { preset: Preset.L, bold: true, uppercase: true, onClick: handleRefreshPage }, "Try again"))));
};
